module.exports = __webpack_public_path__ + "img/allsq.75c0c323.png";